<template>
  <Modal>
      <h2>Edit Action Card Media</h2>
      <div class="grid" v-if="getMedia && getMedia.length">
        <div
          :key="`media.title-${index}`"
          :title="`${media.title} - ${media.fileName}`"
          v-for="(media, index) in getMedia"
        >
          <img :src="media.thumbnail" @click="newselectActiveMedia(media)" :alt="media.title" />
          <h5>{{media.title}} {{media.mmId ? ` - mmId ${media.mmId}` : ''}}</h5>
        </div>
      </div>
    <div
        class="no-media"
        v-if="!getMedia.length"
    >
    <h3>No Media found for this market.</h3>
    <router-link class="button__action" to="/media">Manage Media</router-link>
    </div>
      <button class="button__action" @click="loadMoreMedia" v-if="getMedia.length >= 20">Load More</button>
  </Modal>
</template>
<script>
import Modal from '../general/Modal'
import LibraryGrid from '../general/LibraryGrid';
import MediaCard from '../general/MediaCard';
import store from '../../store';
import Services from '../../services/Services.js';
export default {
  name: 'AddMediaToCard',
  components: {
    LibraryGrid,
    MediaCard
  },
  methods: {
    newselectActiveMedia(media){
      store.commit('setActiveMedia', media);
      if(store.getters.getActiveLocalRecord) {
        let activeRecord = {...store.getters.getActiveLocalRecord};
        activeRecord.mediaId = media;
        store.commit('setActiveLocalRecord', activeRecord);
      }
      store.commit('hideModals', true);
    },
    loadMoreMedia() {
      if (this.moreMedia) {
        let count = this.getMedia[this.getMedia.length - 1].position - 1;
        this.last = count;
        Services.getMediaByMarketForAC(this.marketId, null, null, count, this.moreMedia, (res) => {
          this.moreMedia = res.more;
        });
      }
    },
  },
  computed: {
    getMedia(){
      return store.getters.getMedia;
    }
  },
  data(){
    return {
      last: null,
      moreMedia: true,
      marketId: null
    }
  },
  mounted() {
    const activeLocale = store.getters.getActiveLocale;
    const markets = store.getters.getMarkets;

    console.log('markets', markets);
    const marketId = markets.filter(market => (market.locale === activeLocale))[0]._id || null;

    this.marketId = marketId;

    console.log(marketId)

    Services.getMediaByMarketForAC(marketId, false, false, false, false, (res) => {
      this.moreMedia = res.media;
    });
  },
  components: {
    Modal
  },
  beforeDestroy(){
    store.commit('setMedia', null);
  }
}
</script>
<style lang="scss" scoped>
h2{
  text-align: center;
  margin-bottom: 0;
  margin-top: 2rem;
}

.button__action {
    display: block;
}

h3 {
    text-align: center;
}

.no-media {
    display: flex;
    flex-direction: column;
}

.grid {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 2rem;

  > div {
    padding: 0.5rem;
    width: 25%;

    @media all and (max-width:1024px){
      width: 50%;
    }

    @media all and (max-width:640px){
      width: 100%;
    }

    img {
      cursor: pointer;
      max-width: 100%;
      height: auto;
    }
  }
}

.button__action {
  display: block;
  margin: 0 auto 2rem;

  &--remove {
    margin-bottom: 2rem;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/modals/AddMediaToCard.vue